/**
 * Reposition Keystone's cart edit button in the cart drawer so it sits
 * above the quantity controls for each line item.
 */
(function () {
  const REPOSITIONED_CLASS = 'key-cart-edit-btn--repositioned';
  const QUANTITY_FLEX_SELECTOR = '.flex.justify-start.items-start';

  function getCartDrawer(root = document) {
    if (root.matches?.('[data-cart-drawer]')) {
      return root;
    }

    return root.querySelector('[data-cart-drawer]');
  }

  function isCorrectlyPositioned(editButton, quantityFlex) {
    return editButton.nextElementSibling === quantityFlex;
  }

  function repositionEditButton(editButton) {
    const lineItem = editButton.closest('[data-line-item-key]');

    if (!lineItem || lineItem.hasAttribute('data-tile-quick-buy')) {
      return false;
    }

    const quantityFlex = lineItem.querySelector(QUANTITY_FLEX_SELECTOR);

    if (!quantityFlex) {
      return false;
    }

    const quantityColumn = quantityFlex.parentElement;

    if (!quantityColumn) {
      return false;
    }

    if (isCorrectlyPositioned(editButton, quantityFlex)) {
      editButton.classList.add(REPOSITIONED_CLASS);
      return true;
    }

    quantityColumn.insertBefore(editButton, quantityFlex);
    editButton.hidden = false;
    editButton.style.removeProperty('display');
    editButton.removeAttribute('aria-hidden');
    editButton.classList.add(REPOSITIONED_CLASS);

    return true;
  }

  function repositionCartDrawerEditButtons(root = document) {
    const drawer = getCartDrawer(root);

    if (!drawer) {
      return;
    }

    drawer.querySelectorAll('.key-cart-edit-btn').forEach((editButton) => {
      repositionEditButton(editButton);
    });
  }

  function ensureStyles() {
    if (document.getElementById('keystone-cart-drawer-edit-btn-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'keystone-cart-drawer-edit-btn-styles';
    style.textContent = `
      [data-cart-drawer] .${REPOSITIONED_CLASS} {
        display: block;
        margin-bottom: 0.5rem;
      }
    `;
    document.head.appendChild(style);
  }

  function refreshCartDrawerEditButtons(root = document) {
    ensureStyles();
    repositionCartDrawerEditButtons(root);
  }

  document.addEventListener('DOMContentLoaded', () => refreshCartDrawerEditButtons());
  document.addEventListener('baseline:cart:afteradditem', () => refreshCartDrawerEditButtons());
  document.addEventListener('baseline:cart:update', () => refreshCartDrawerEditButtons());
  document.addEventListener('baseline:cart:cartqtychange', () => refreshCartDrawerEditButtons());

  const observer = new MutationObserver(() => {
    refreshCartDrawerEditButtons();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  refreshCartDrawerEditButtons();
})();
